import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

export default function SectionSolarStation() {
    const { t } = useLang('theProduct.SectionSolarStation');

    return (
        <div className={styles.SectionSolarStation}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} label={t('label')} />
            <div className="solar-station-container">
                <div className="feature-list">
                    <div className="feature-item">{t('feature1')}</div>
                    <div className="feature-item">{t('feature2')}</div>
                    <div className="feature-item">{t('feature3')}</div>
                </div>
                <EcoSpaceSmall />
                <div className="content">
                    <div className="product-image">
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1748137324139/SolarStation_pc.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1748137324139/SolarStation_pc.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1748424162779/SolarStation_h5.png"
                        />
                    </div>
                    <div className="data-list">
                        <div className="data-item">
                            <div className="data-value">{t('data1')}</div>
                            <div className="data-desc">{t('data1_desc')}</div>
                        </div>
                        <div className="data-item">
                            <div className="data-value">{t('data2')}</div>
                            <div className="data-desc">{t('data2_desc')}</div>
                        </div>
                        <div className="data-item">
                            <div className="data-value">{t('data3')}</div>
                            <div className="data-desc">{t('data3_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <EcoSpace />
        </div>
    );
}
